module.exports = __webpack_public_path__ + "img/a.09e29f1b.png";